import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.scss';

const Footer: React.FC = () => {
  const onNavClick = (): void => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  };

  return (
    <footer className="app-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Florida First Psychiatry</h3>
            <div className="contact-info-compact">
              <div className="contact-item-compact">
                <span>Phone: (850) 765-8120</span>
              </div>
              <div className="contact-item-compact">
                <span>Fax: (850) 270-7733</span>
              </div>
              <div className="contact-item-compact">
                <span>info@ffps.pro</span>
              </div>
              <div className="contact-item-compact">
                <span>1820 Miccosukee Commons Drive<br />Tallahassee, FL 32308</span>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/" onClick={onNavClick}>Home</Link></li>
              <li><Link to="/about-overview" onClick={onNavClick}>About Us</Link></li>
              <li><Link to="/contact" onClick={onNavClick}>Contact</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">&copy; 2024 Florida First Psychiatry. All rights reserved.</p>
            <div className="footer-bottom-links">
              <Link to="/privacy-policy" onClick={onNavClick}>Privacy Policy</Link>
              <Link to="/terms-of-service" onClick={onNavClick}>Terms of Service</Link>
            </div>
            <p className="powered-by">Powered By <a href="https://softagesystems.com" target="_blank" rel="noopener">SoftAge Systems Inc</a></p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

